import { __read, __awaiter, __generator } from 'tslib';
import { useState } from 'react';
import useDidMount from '../useDidMount/index.js';
import useLoading from '../useLoading/index.js';

var useDataInit = function (apiFun, options) {
    var _a = options || {}, resHandler = _a.resHandler, needLoading = _a.needLoading;
    var setLoading = useLoading().setLoading;
    var _b = __read(useState(), 2), data = _b[0], setData = _b[1];
    var _c = __read(useState(), 2), data2 = _c[0], setData2 = _c[1];
    useDidMount(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        needLoading && setLoading(true);
                        return [4 /*yield*/, apiFun()];
                    case 1:
                        res = _a.sent();
                        setLoading(false);
                        setData(res.data.data);
                        if (resHandler) {
                            setData2(resHandler(res.data.data));
                        }
                        return [2 /*return*/];
                }
            });
        }); })();
    });
    return {
        data: data,
        data2: data2,
        didMountData: data2,
    };
};

export { useDataInit as default };
